export const USER = "lamtrac_user_info";
export const LANG = "lamtrac_i18next";
export const ADMIN = "admin";
export const DEALER = "dealer";
export const PENDING = 'pending';
export const DENIED = 'denied';
export const ACCEPTED = 'accepted';
